import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalOptions } from 'app/common/models/models';
import { ModalService } from 'app/common/services/modal.service';
import { iconLink, iconTrash } from 'app/common/utils/icons.utils';
import { IngrediantService } from 'app/services/ingrediant.service';
import { Group, Recipe } from 'app/models/recipe.model';
import { TranslateService } from '@ngx-translate/core';
import { ReceiptItem } from 'app/models/recipe.model';
import { BaseComponent } from 'app/common/components/base.component';
import { IngrediantSearchModalComponent } from '../ingrediant-search-modal/ingrediant-search-modal.component';
import { PopupInfoComponent } from '../../popup-info/popup-info.component';

@Component({
	selector: 'receipt-editor',
	templateUrl: './recipe-editor.component.html',
	styleUrls: ['../receipt-creation.component.scss']
})
export class ReceiptEditorComponent extends BaseComponent implements OnInit{
	_recipe: Recipe;
	iconLink = iconLink;
	@Input("recipe") set recipe(recipe) {
		this._recipe = recipe;
		this._updateRecipe();
	};
	get recipe() {return this._recipe;}

	private _updateRecipe = () => {
		if (this.recipe) {
			this._receiptName = this.recipe.recipeName;
			this._recipeLink = this.recipe.recipeLink;
			this.servingNumber = this.recipe.servings;
			this.ingrediants = this.recipe.ingrediants;
		}
		
		this.updatesValues();
	}

	@Output() recipeUpdates: EventEmitter<Recipe> = new EventEmitter();

	constructor(
		private _modalService: ModalService,
		private _ingrediantService: IngrediantService,
		private _translateService: TranslateService
	) {
		super();
	}
	openRecipeLink = () => {
		if (this._recipeLink) {
			let link = this._recipeLink;
			if ((""+link).toLowerCase().startsWith("http://") == false && (""+link).toLowerCase().startsWith("https://") == false) link = "https://"+ link
			window.open(link, "_new");
		}
	}
	isAutenticated = false;
	// data = [];
	_receiptName = "";
	_recipeLink = "";
	get recipeName() {
		return this._receiptName;
	}
	set recipeName(name) {
		if (!this.recipe) {
			this.recipe = new Recipe();
		}
		this.recipe.recipeName = this._receiptName = name;
		this.recipeUpdates.emit(this.recipe);
	}
	get recipeLink() {
		return this._recipeLink;
	}
	set recipeLink(link) {
		if (!this.recipe) {
			this.recipe = new Recipe();
		}
		this.recipe.recipeLink = this._recipeLink = link;
		this.recipeUpdates.emit(this.recipe);
	}
	servingNumber = 1;
	ingrediants: ReceiptItem[] = [];
	
	// classes = ["A", "B", "C", "D", "E"];
	fishClass: string=undefined;
	iconCancel = iconTrash;
	downloadMsgShotMessage = "";
	downloadMessage = "";


	ngOnInit() {
		this._ingrediantService.getAll().subscribe((result) => {
			result.forEach((g) => {
				this.recursiveGetFoodItems(g);
			})
		});
	}
	
	
	get carbonFootprint() {
		let value = 0;
		this.ingrediants.forEach((e) => {
			value += e.carbonFootprint * e.quantity / 1000;
		})
		return value/this.servingNumber;
	}
	get waterFootprint() {
		let value = 0;
		this.ingrediants.forEach((e) => {
			value += e.waterFootprint * e.quantity / 1000;
		})
		return value/this.servingNumber;
	}
	get fishQualitySustainability() {
		return "A";
	}

	get energy () {
		let value = 0;
		this.ingrediants.forEach((e) => {
			value += e.energy * e.quantity / 100;
		})
		return Math.round((value/this.servingNumber)*100)/100; ;
		
	}

	addServing = (n: number) => {
		if (this.servingNumber+n >= 1) this.servingNumber = this.servingNumber+n;
		else this.servingNumber = 1;
		this.updatesValues();
	}
	get servingLabel() {
		if (this.servingNumber == 0) return this._translateService.instant("recipePage.n_servings");
		if (this.servingNumber == 1) return this.servingNumber + " " + this._translateService.instant("recipePage.serving");
		return this.servingNumber + " " + this._translateService.instant("recipePage.servings");
	}


	private recursiveGetFoodItems = (group: Group) => {
		if (group.items && group.items.length > 0) {
			group.items.forEach((item) => {
				let viewItem: ReceiptItem = new ReceiptItem();
				Object.assign(viewItem, item);
				viewItem.label = item.id;
				viewItem.quantity = 100;
				viewItem.measurementUnit = (item.unitsWaterfootprint == "liters water/kg")? "g": "ml";
				// this.data.push(viewItem);
			});
		}
		if (group.subgroups && group.subgroups.length > 0) {
			group.subgroups.forEach((g) => {
				this.recursiveGetFoodItems(g);
			})
		}
	}

	// getItem = (id) => {
	// 	if (id) {
	// 		return this.data.filter((item => {
	// 			return item.id == id;
	// 		}))[0];
	// 	}
		
	// }
	
	addItemRequest = () => {
		let modalOption: ModalOptions<any> = {
			size: 'xl',
			callback: (res) => {
				if (res) {
					let found = false;
					this.ingrediants.forEach((el) => {
						if (el.id == res.id) {
							found = true;
						}
					})
					if (!found) {
						let viewItem: ReceiptItem = new ReceiptItem();
						Object.assign(viewItem, res);
						viewItem.label = res.id;
						viewItem.quantity = 100;
						viewItem.measurementUnit = (res.unitsWaterfootprint == "liters water/kg")? "g": "ml";
						this.ingrediants.push(viewItem);
						this.updatesValues()
					}
				}
					
			}
		}
		let data = {
			
		}
		this._modalService.show(IngrediantSearchModalComponent, data, modalOption);
	}

	
	
	removeItem = (find) => {
	
		this.ingrediants = this.ingrediants.filter((item) => {
			return item.id != find.id;
		})
		this.updatesValues();
	}
	
	baseColors = ["#fab726", "#d82239", "#91c467","#1e8ca8", "#dd8c33", "#50adea"];
	
	legendColor = ["#fab726", "#1e8ca8", "#d82239", "#91c467"];
	legendLabels = [
		'nutritionalLabels.Proteins',
		'nutritionalLabels.Fat',
		'nutritionalLabels.Saturated Fat', "nutritionalLabels.Monounsaturated Fat", "nutritionalLabels.Polyunsaturated Fat", "nutritionalLabels.Carbohydrates", "nutritionalLabels.Soluble", "nutritionalLabels.Fiber"];
		
	allData;
	updatesValues = () => {
		if (this.ingrediants.length > 0) {
			let energySeries = [0,0,0,0];
			this.allData = [0,0,0,0,0,0,0,0];
			let series = [];
			let colors = [];
			let labels = [];
			this.ingrediants.forEach((el, index) => {
				energySeries[0] = energySeries[0] + (el.proteins * el.quantity / 100);
				energySeries[1] = energySeries[1] + (el.fat * el.quantity / 100);
				energySeries[2] = energySeries[2] + (el.carbohydrates * el.quantity / 100);
				energySeries[3] = energySeries[3] + (el.fiber * el.quantity / 100);

				this.allData[0] = this.allData[0] + (el.proteins * el.quantity / 100);
				this.allData[1] = this.allData[1] + (el.fat * el.quantity / 100);
				this.allData[2] = this.allData[2] + (el.saturatedFat * el.quantity / 100);
				this.allData[3] = this.allData[3] + (el.monounsaturatedFat * el.quantity / 100);
				this.allData[4] = this.allData[4] + (el.polyunsaturatedFat * el.quantity / 100);
				this.allData[5] = this.allData[5] + (el.carbohydrates * el.quantity / 100);
				this.allData[6] = this.allData[6] + (el.soluble * el.quantity / 100);
				this.allData[7] = this.allData[7] + (el.fiber * el.quantity / 100);
				
				series.push(Math.round(((el.carbonFootprint * el.quantity / 1000)/this.servingNumber) * 100)/100);
				colors.push(this.baseColors[index%this.baseColors.length]);
				labels.push(this._translateService.instant(el.label));
			})
			for (let i=0; i< energySeries.length; i++) energySeries[i]= Math.round((energySeries[i]/this.servingNumber)*100)/100;
			for (let i=0; i< this.allData.length; i++) this.allData[i]= Math.round((this.allData[i]/this.servingNumber)*100)/100;
			
			
			this.pieChartOptions.series = series;
			this.pieChartOptions.colors = colors;
			this.pieChartOptions.labels = labels;
			
			this.donutChartOptions.series =energySeries;
			this.donutChartOptions.labels = [
				this._translateService.instant('nutritionalLabels.Proteins'),
				this._translateService.instant('nutritionalLabels.Fat'),
				this._translateService.instant("nutritionalLabels.Carbohydrates"),
				this._translateService.instant('nutritionalLabels.Fiber')];

			let plotOptions: any = new Object();
			Object.assign(plotOptions, this.donutChartOptions.plotOptions);
			plotOptions.pie.donut.labels.total.label = `${this.energy} Kcal`;
			this.donutChartOptions.plotOptions = plotOptions;
		}
			
		else {
			// this.donutChartOptions.series = this.radialBarChartOptions.series = [0, 0, 0, 0, 0,0];
			// this.donutChartOptions.series = [0,0,0,0,0,0,0,0];
			this.donutChartOptions.series = [0,0,0,0];
			this.donutChartOptions.labels = [
				this._translateService.instant('nutritionalLabels.Proteins'),
				this._translateService.instant('nutritionalLabels.Fat'),
				this._translateService.instant("nutritionalLabels.Carbohydrates"),
				this._translateService.instant('nutritionalLabels.Fiber')];
			let series = [];
			let colors = [];
			let labels = [];

			this.pieChartOptions.series = series;
			this.pieChartOptions.colors = colors;
			this.pieChartOptions.labels = labels;
		}

		if (this.recipe) {
			this.recipe.recipeName = this.recipeName;
			this.recipe.recipeLink = this.recipeLink;
			
			this.recipe.servings = this.servingNumber;
			this.recipe.ingrediants = this.ingrediants;
			this.recipe.envScoreClass = this.envScoreClass;
			this.recipeUpdates.emit(this.recipe);
		}
	}


	donutChartOptions = {
		plotOptions: {
			pie: {
				donut: {
					labels: {
						show: true,
						name: {
							offsetY: 10,
						},                        
						total: {
							show: true,
							showAlways: true,
							fontSize: '22px',
							fontFamily: 'Helvetica, Arial, sans-serif',
							fontWeight: 600,
							color: "#1a8ca7",
							label: `${this.energy} Kcal`,
							formatter: function (w) {
								return ""
							}
						}
					}
				}
			}
		}, 
		chart: {
		  type: 'donut',
		  height: 320
		},
		colors: ["#fab726", "#1e8ca8", "#d82239", "#91c467"],
		labels: ['Proteins', "Fat", "Carbohydrates", "Fiber"],
		series: [0,0,0,0],
		
		legend: {
			show: false
		},
		dataLabels: {
			enabled: true,
			formatter: function (val) {
				return Math.floor(val) + '%'
			},
			total: {
				show: true,
				label: 'Total',
				// color: $label_color,
				formatter: function (w) {
				  // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
				  return '249'
				}
			  }
		  },
		responsive: [{
		  breakpoint: 576,
		  options: {
			chart: {
			  width: 300
			},
			legend: {
			  position: 'bottom'
			}
		  }
		}],

		
	}



	pieChartOptions = {
		chart: {
		  type: 'pie',
		  height: 320
		},
		colors: [],
		labels: [],
		series: [],
		legend: {
		 show: false
		},
		responsive: [{
		  breakpoint: 576,
		  options: {
			chart: {
			  width: 300
			},
			legend: {
			  position: 'bottom'
			}
		  }
		}]
	  }

	get hasMoreIngredients() {
		return this.ingrediants && this.ingrediants.length>0
	}



	get fishScoreClass() {
		let counter = 0;
		let presentLow = false;
		let presentModerate = false;
		let presentOptimal = false;

		this.ingrediants.forEach((element: ReceiptItem) => {
			if (element.blueSustainabilityIndex == "LIMIT") {
				presentLow = true;
				counter++;
			}
			else if (element.blueSustainabilityIndex == "OPTIMAL") {
				presentOptimal = true;
				counter++;
			}
			else if (element.blueSustainabilityIndex == "MODERATE" || element.blueSustainabilityIndex == "MODERATE/ LIMIT") {
				presentModerate = true;
				counter++;
			}
		})
		if (presentLow) {
				this.fishClass = (counter > 1)? "limit-color-more-than-1": "limit-color";
		}
		else if (presentModerate) {
			this.fishClass =  (counter > 1)? "moderate-color-more-than-1": "moderate-color";
		}
		else if (presentOptimal) {
			this.fishClass =  (counter > 1)? "optimal-colo-more-than-1r": "optimal-color";
		}
		else {
			this.fishClass = undefined;
		}
		return this.fishClass;
	}

	private ceckFishClass() {
		if (this.fishClass) {
			if (this.fishClass.startsWith("limit") ) this.downloadMessage += " " + this._translateService.instant("recipePage.downloadMessage_fish_limit")
			else if (this.fishClass.startsWith("moderate") ) this.downloadMessage += " " + this._translateService.instant("recipePage.downloadMessage_fish_moderate");
		}
	}
	get envScoreClass() {
		let result;
		if (this.carbonFootprint <= 0.2) {
			this.downloadMsgShotMessage = "recipePage.downloadTitleMessage_very_good";
			this.downloadMessage = this._translateService.instant("recipePage.downloadMessage_A");
			result = "A";
		}
		if (this.carbonFootprint > 0.2 && this.carbonFootprint <=0.5 ) {
			this.downloadMsgShotMessage = "recipePage.downloadTitleMessage_very_good";
			this.downloadMessage = this._translateService.instant("recipePage.downloadMessage_B");
			result = "B";
		}
		if (this.carbonFootprint > 0.5 && this.carbonFootprint <=1 ) {
			this.downloadMsgShotMessage = "recipePage.downloadTitleMessage_good";
			this.downloadMessage = this._translateService.instant("recipePage.downloadMessage_C");
			result = "C";
		}
		if (this.carbonFootprint > 1 && this.carbonFootprint <=1.2 ) {
			this.downloadMsgShotMessage = "recipePage.downloadTitleMessage_attention";
			this.downloadMessage = this._translateService.instant("recipePage.downloadMessage_D");
			result = "D";
		}
		if (this.carbonFootprint > 1.2) {
			this.downloadMsgShotMessage = "recipePage.downloadTitleMessage_attention";
			this.downloadMessage = this._translateService.instant("recipePage.downloadMessage_E");
			result = "E";
		}
		this.ceckFishClass();
		return result;

		
	} 

	

	openLearnMore = () => {
		let modalOption: ModalOptions<any> = {
			size: 'xl',
			callback: (res) => {}
		}
		let data = {
			sectionId: "RECIPE"
		}
		this._modalService.show(PopupInfoComponent, data, modalOption);
	}

	openFishIndicator = () => {
		let modalOption: ModalOptions<any> = {
			size: 'xl',
			callback: (res) => {}
		}
		
		let data = {
			sectionId: this.fishClass
		}
		
		this._modalService.show(PopupInfoComponent, data, modalOption);
	}


	// @ViewChild('fileInput') fileInput: ElementRef;
	// public loadReceipt = () => {
	// 	this.fileInput.nativeElement.click();
	// }
	// public fileChanged = (e) => {
	// 	let file = e.target.files[0];
	// 	let fileReader = new FileReader();
	// 	fileReader.onload = (e) => {
	// 		try {
	// 			console.log("result: " + fileReader.result);

	// 			let data = JSON.parse(""+fileReader.result);

	// 			this.recipeName = data.recipeName;
	// 			this.servingNumber = data.servings;
	// 			this.ingrediants = data.ingrediants;
	// 			this.updatesValues();
	// 			this._toastService.showSuccess(this._translateService.instant("recipePage.loadReciptSuccess"));

	// 		} catch (error) {
	// 			this._toastService.showDanger(this._translateService.instant("recipePage.loadReciptError"));
	// 		}
			
	// 	}
	// 	if (file)
	// 		fileReader.readAsText(file);
	// }

	// public storeRecipe = () => {
	// 	if (this.isAutenticated) {
	// 		let recicpe: Recipe = {
	// 			recipeName: this.recipeName,
	// 			ingrediants: this.ingrediants,
	// 			servings: this.servingNumber
	// 		}
	// 		this._recipeService.saveOrUpdate(recicpe).subscribe((result) => {
	// 			this._toastService.showSuccess(this._translateService.instant("recipePage.downloadReceiptMessage"));
	// 		})
			
	// 	}
		
	// }

	// public saveReceipt = () => {
	// 	let textResult: Recipe = {
	// 		recipeName: this.recipeName,
	// 		ingrediants: this.ingrediants,
	// 		servings: this.servingNumber
	// 	}
		
	// 	// Create a blob from the CSV file content
	// 	const blob = new Blob([JSON.stringify(textResult)], { type: 'text/json' });
	  
	// 	// Create a link to the blob
	// 	const link = document.createElement('a');
	// 	link.href = window.URL.createObjectURL(blob);
	// 	link.download = (this.recipeName && this.recipeName.trim())? this.recipeName.trim() + ".switch": 'receipt.switch';
	// 	link.click();
	// 	this._toastService.showSuccess(this._translateService.instant("recipePage.downloadReceiptMessage"));
	// }


	// displayMediaOptions = {
	// 	video: {
	// 	  displaySurface: "browser",
	// 	},
	// 	audio: {
	// 	  suppressLocalAudioPlayback: false,
	// 	},
	// 	preferCurrentTab: false,
	// 	selfBrowserSurface: "exclude",
	// 	systemAudio: "include",
	// 	surfaceSwitching: "include",
	// 	monitorTypeSurfaces: "include",
	// };


	//  capture = async () => {
	// 	const canvas = document.createElement("canvas");
	// 	const context = canvas.getContext("2d");
	// 	const video = document.createElement("video");
	  
	// 	try {
	// 	  const captureStream = await (<any>navigator).mediaDevices.getDisplayMedia();
	// 	  timer(500).subscribe((r) => {
	// 		video.srcObject = captureStream;
	// 		context.drawImage(video, 1800, 1800);
	// 	  //   context.drawImage(video, 0, 0, 800, 800);
	// 		const frame = canvas.toDataURL("image/png");
	// 		captureStream.getTracks().forEach(track => track.stop());
	// 	  //   window.location.href = frame;
  
	// 		  console.log(frame);
			  
	// 		const link: any = document.createElement('a')
			  
  
	// 		  link.href = frame;
	// 		  link.target = '_self'
	// 		  link.fileName = 'test_file_download.gif'
	// 		  link.download = true
	// 		  link.click()
	// 	  })
		 
			
	// 	} catch (err) {
	// 	  console.error("Error: " + err);
	// 	}
	//   };
	
}